import type { Vertex } from '@phi/jcore';
import { round_decimals } from '@features/decimal-approximation';
import { reactive, ref } from 'vue';

export const read_coords_props = reactive({
    left: 0,
    top: 0,
    x: 0,
    y: 0,
    z: 0,
    vid: undefined as undefined | Vertex,
});

export const showing_read_coordinates_modal = ref(false);

export function show_read_coords(left: number, top: number, x: number, y: number, z: number, vertex: Vertex) {
    read_coords_props.left = left;
    read_coords_props.top = top;
    read_coords_props.x = round_decimals(x);
    read_coords_props.y = round_decimals(y);
    read_coords_props.z = round_decimals(z);
    read_coords_props.vid = vertex;
    showing_read_coordinates_modal.value = true;
}
